import {
    IS_LOADING,
    TOGGLE_GROUP_MODAL_MENU,
    TOGGLE_MOBILE_MENU
} from '../constants/ActionTypes';

function getInitialState() {
    return {
        isLoading: false,
        groupModalOpen: false,
        toggleMobileMenu: false
    };
}

function CommunityPageReducer(state = getInitialState(), action = null) {
    switch (action.type) {

    case TOGGLE_GROUP_MODAL_MENU:
        return Object.assign({}, state, {groupModalOpen: !state.groupModalOpen});

    case TOGGLE_MOBILE_MENU:
        return Object.assign({}, state, {toggleMobileMenu: !state.toggleMobileMenu});


    case IS_LOADING:
        return Object.assign({}, state, {
            isLoading: action.isLoading
        });

    default:
        return state;
    }
}

export default CommunityPageReducer;
